import classNames from 'classnames';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { roomAllocationPropTypes, roomsPropTypes } from './PropTypes';
import { roomTypeCodes } from './helpers';

import Checkbox from '../Atoms/Checkbox';

const propTypes = exact({
  fieldNamePrefix: PropTypes.string.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  rooms: PropTypes.arrayOf(roomsPropTypes).isRequired,
  selectedValue: roomAllocationPropTypes.isRequired,
});

const defaultProps = {
  isDisabled: false,
  isInvalid: false,
};

function RoomAllocation({ handleFieldChange, ...props }) {
  const containerClasses = classNames('RoomAllocation', { invalid: props.isInvalid });

  const value = props.selectedValue;

  const rooms = props.rooms.map((room) => {
    const roomModified = room;

    roomModified.items = room.items.map((item) => {
      const itemModified = item;
      if (room.code === roomTypeCodes.SINGLE_ROOM && item.occupancy >= 1)
        itemModified.isFull = true;
      if (room.code === roomTypeCodes.DOUBLE_ROOM && item.occupancy >= 2)
        itemModified.isFull = true;
      if (room.code === roomTypeCodes.TWIN_ROOM && item.occupancy >= 2) itemModified.isFull = true;
      return itemModified;
    });

    return roomModified;
  });

  return (
    <div className={containerClasses}>
      <div className="RoomAllocation_group">
        {rooms.map((room) =>
          room.items.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div className="RoomAllocation_field" key={`${room.key}${index}`}>
              {props.isDisabled && `${room.roomName} ${index + 1}`}
              {!props.isDisabled && (
                <Checkbox
                  fieldID={`${props.fieldNamePrefix}.roomAllocation.${room.key}.${index}`}
                  fieldName={`${props.fieldNamePrefix}.roomAllocation`}
                  fieldValue={`${room.key},${index}`}
                  handleChange={handleFieldChange}
                  inputType="radio"
                  isChecked={value.key === room.key && value.index === index}
                  isDisabled={props.isDisabled || item.isFull}
                  modifier={`ghost ${item.isFull ? 'deactive' : ''}`}
                  text={`${room.roomName} ${index + 1} ${item.isFull ? '(full)' : ''}`}
                />
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

RoomAllocation.propTypes = propTypes;
RoomAllocation.defaultProps = defaultProps;

export default RoomAllocation;
